// src/utils/sharedListsApi.js
//
// The public side of the restaurant lists (backend routes/sharedLists.ts),
// read without an account: a list by its share code, the hit-parade.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
const BASE = `${API_BASE_URL}/v1/lists`;

async function get(path) {
  const r = await fetch(`${BASE}${path}`);
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(data.error || `HTTP_${r.status}`);
    err.status = r.status;
    throw err;
  }
  return data;
}

export const sharedList = (code) => get(`/share/${encodeURIComponent(code)}`);
// The comments under a public list (routes/listSocial.ts), read-only here.
export const listComments = (id) => get(`/${Number(id)}/comments`);
// A public list's approved photos, by place (placeKey of each item), and their images.
export const listPhotos = (id) => get(`/${Number(id)}/photos`).then((r) => r.photos);
export const photoUrl = (id, thumb = false) => `${BASE}/photos/${Number(id)}${thumb ? '/thumb' : ''}.jpg`;
export const charts = (period) => get(`/charts?period=${period === 'all' ? 'all' : '30d'}`).then((r) => r.lists);

// The YummiTracker app (ClientApp-react-native): its link scheme and stores.
export const APP_LINK = (code) => `clientappreactnative://l/${encodeURIComponent(code)}`;
export const APP_STORE_URL = 'https://apps.apple.com/app/id1509052798';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.qrproofs.yummitracker';
